import { useEffect, useState } from "react";
import { LottieSvg } from "lottie-react";
import animationData from "@/assets/connectid-workflow.json";

interface ConnectIDLottieProps {
  className?: string;
  "data-testid"?: string;
}

export function ConnectIDLottie({
  className = "",
  "data-testid": dataTestId = "connectid-lottie",
}: ConnectIDLottieProps) {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const updatePreference = () => setPrefersReducedMotion(mediaQuery.matches);

    updatePreference();
    mediaQuery.addEventListener("change", updatePreference);
    return () => mediaQuery.removeEventListener("change", updatePreference);
  }, []);

  return (
    <div
      className={`w-full overflow-hidden ${className}`}
      data-testid={dataTestId}
      role="img"
      aria-label="ConnectID identity verification workflow"
    >
      <LottieSvg
        src={animationData}
        autoplay={!prefersReducedMotion}
        loop={!prefersReducedMotion}
        rendererSettings={{ preserveAspectRatio: "xMidYMid meet" }}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}